<template>
  <a-button type="primary" class="btn-check-reason" v-bind="$attrs" @click="handleCheckReason">
    {{ $t('shen-he-shi-bai-yuan-yin') }}
  </a-button>
</template>

<script setup lang="ts">
import type { Template } from '~/api/interface';
import { getTagIDs } from '~/features/template';
import { useConfirm } from '~/hooks/useModal/modals/confirm';
const { $t } = useNuxtApp();
const cardItem: any = inject<Template>('card-item');
const ctx: any = inject('personal-page-ctx');

const handleCheckReason = () => {
  trackEvent(TRACK_EVENT.CLICK_VIEW_VERIFY_REJECT_REASON, {
    template_id: cardItem.id,
    template_title: cardItem.name,
    tags: getTagIDs(cardItem.tag_ids).map(item => item.tag_name),
    failure_reason: cardItem.review_deny_reason,
  });

  const model = useConfirm({
    icon: 'warning',
    title: $t('shi-bai-yuan-yin'),
    description: cardItem.review_deny_reason || $t('wei-zhi-cuo-wu'),
    okText: $t('zhong-xin-shen-he'),
    cancelText: $t('guan-bi'),
    onCancel() {
      model?.destroy();
    },
    onOk() {
      ctx.actionBatchRepublish(cardItem);
      model?.destroy();
    },
  });
};
</script>
<style scoped lang="scss">
.btn-check-reason {
  flex: 1;
  border-radius: 6px;
}
</style>
